/**
 * 결과 카드 ErrorBoundary (spec D-12 — ErrorBoundary 2겹).
 *
 * @spec:2026-09-29-처방검토-판정기록-조회화면
 *
 * repo에 ErrorBoundary가 0건이라(현황 6) 클래스 컴포넌트 1개를 신설해 두 곳에 쓴다.
 * ① ResultView 전체 — 카드 밖 최상위 순회(downgradedItemCount·prescriptionFindings 등)가
 *    던져도 페이지(원문 뷰·목록 링크)는 유지한다. ② 카드 단위 — 한 카드가 던지면 그 카드만 폴백.
 * 옛 형식 결과 1건이 상세 전체를 흰 화면으로 만들던 것을 막는다.
 * onShowRaw가 있으면 폴백에 [원문 보기] 버튼을 그린다(없으면 생략 — 테스트 패널은 안 넘긴다).
 */
import React from "react";
import Button from "components/atoms/Button";
import { Card, InfoLine, Row } from "./style";

interface Props {
  onShowRaw?: () => void;
  children: React.ReactNode;
}

interface State {
  hasError: boolean;
}

export class ResultErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(): State {
    return { hasError: true };
  }

  render(): React.ReactNode {
    if (this.state.hasError) {
      return (
        <Card data-testid="dose-card-error">
          <InfoLine>표시할 수 없는 형식</InfoLine>
          {this.props.onShowRaw && (
            <Row>
              <Button
                buttonType="button"
                type="Text"
                size="XSmall"
                variant="Outlined"
                color="Secondary"
                onClick={this.props.onShowRaw}
                data-testid="dose-show-raw"
              >
                원문 보기
              </Button>
            </Row>
          )}
        </Card>
      );
    }
    return this.props.children;
  }
}

export default ResultErrorBoundary;
